module.exports = new __parcel__URL__("Carrom.4340787d.png").toString();